module.exports = __webpack_public_path__ + "media/images/icon_a1-75c2694a9a36f4ec075d66a0cc46c372.png";